import { useState, useEffect, useLayoutEffect} from 'react';
import styles from '../styles/body.module.scss'
import btnStyles from '../styles/buttons.module.scss'
import {Box, TextField} from '@mui/material';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import axios from '../api/axios';
import useAxiosFunction from '../hooks/useAxiosFunction';
import{BottomNavigation, BottomNavigationAction} from '@mui/material'
import { useNavigate } from 'react-router-dom';

export default function DrivingQuestionsPage({userId, siteId, drivingToSite, asDriver,
     drivingToSiteNew, setDrivingToSiteNew, asDriverNew,
      setAsDriverNew, registrationNumber, setRegistrationNumber,
       transportType, setTransportType, transportSize,
        setTransportSize, fuelType, setFuelType,}) {

  const navigate = useNavigate();
  const goBack = () => navigate(-1);
  const [response, error2,loading, axiosFetch] = useAxiosFunction();

  const [result, setResult] = useState(false);

  useLayoutEffect(() => {
    if(result){
      submitAction();
    }
    
  }, [result])


  const [transportTypeError, setTransportTypeError] = useState(false);
  const [transportTypeText, setTransportTypeText] = useState('');

  const [fuelTypeError, setFuelTypeError] = useState(false);
  const [fuelTypeText, setFuelTypeText] = useState('');

  const [registrationNumberError, setRegistrationNumberError] = useState(false);
  const [registrationNumberText, setRegistrationNumberText] = useState('');

  const [transportSizeError, setTransportSizeError] = useState(false);
  const [transportSizeText, setTransportSizeText] = useState('');
  const [engineOptions, setEngineOptions] = useState([]);
  const [fuelOptions, setFuelOptions] = useState([]);
  const [hideFuel, setHideFuel] = useState(false);

  useEffect(() => {
    if(transportType == "car"){
      setEngineOptions([
        {value:"small", label:"Small Car"},
        {value:"medium", label:"Medium Car"},
        {value:"large", label:"Large Car"}
      ]);

      setFuelOptions([
        {value:"petrol", label:"Petrol"},
        {value:"diesel", label:"Diesel"},
        {value:"np_hybrid", label:"Non-Plug-In-Hybrid"},
        {value:"lpg", label:"LPG"},
        {value:"p_hybrid", label:"Plug-in Hybrid Electric Vehicle"},
        {value:"bec", label:"Battery Electric Vehicle"}
      ]);

      setHideFuel(false);
      setFuelType(null);

    }
    else if(transportType == "motorbike"){
      setEngineOptions([
        {value:"small", label:"Small"},
        {value:"medium", label:"Medium"},
        {value:"large", label:"Large"}
      ]);

      setHideFuel(true);
      setFuelType(null);
      
    }
    else if(transportType == "van"){
      setEngineOptions([
        {value:"small", label:"Class I (up to 1.305 tonnes)"},
        {value:"medium", label:"Class II (1.305 to 1.74 tonnes)"},
        {value:"large", label:"Class III (1.74 to 3.5 tonnes)"}
      ]);

      setFuelOptions([
        {value:"petrol", label:"Petrol"},
        {value:"diesel", label:"Diesel"},
        {value:"lpg", label:"LPG"},
        {value:"p_hybrid", label:"Plug-in Hybrid Electric Vehicle"},
        {value:"bec", label:"Battery Electric Vehicle"}
      ]);

      setHideFuel(false);
      setFuelType(null);
      
    }
    
  }, [transportType])


  const handleTransportTypeChange = (event) => {
        setTransportType(event.target.value);
    };

    const handleFuelTypeChange = (event) => {
      console.log("Fuel Type: "+event.target.value);
        setFuelType(event.target.value);
    };

  const handleRegistrationNumberChange  = (newValue) => {
      setRegistrationNumber(newValue);
  };
  const handleTransportSizeChange = (event) => {
      setTransportSize(event.target.value);
  };

  var reg_regex = /^[a-zA-Z0-9 ]{1,50}$/;

  // Helper to check if a value is empty
const isEmpty = (val) => val === null || val === '';

// Helper to reset all error messages
const resetErrors = () => {
  setTransportTypeText('');
  setTransportTypeError(false);
  setFuelTypeText('');
  setFuelTypeError(false);
  setRegistrationNumberText('');
  setRegistrationNumberError(false);
  setTransportSizeText('');
  setTransportSizeError(false);
};

  const nextPage = () =>{
    console.log("alpha")
    let isValid = true;
  resetErrors();

  if (isEmpty(transportType)) {
    setTransportTypeText('Please select a valid vehicle type.');
    setTransportTypeError(true);
    isValid = false;
  }
console.log("bravo");
console.log("transportType: "+transportType);
  if (transportType !== 'motorbike' && isEmpty(fuelType)) {
    setFuelTypeText('Please select a valid fuel type.');
    setFuelTypeError(true);
    isValid = false;
  }

  if (isEmpty(registrationNumber)) {
    setRegistrationNumberText('Please enter a valid vehicle registration number containing only letters, numbers and spaces.');
    setRegistrationNumberError(true);
    isValid = false;
  } else if (!reg_regex.test(registrationNumber)) {
    setRegistrationNumberText('Please enter a valid vehicle registration number containing only letters, numbers and spaces.');
    setRegistrationNumberError(true);
    isValid = false;
  }

  if (isEmpty(transportSize)) {
    setTransportSizeText('Please select a valid engine size.');
    setTransportSizeError(true);
    isValid = false;
  }
  console.log("echo")
  if(isValid){
    submit();
  }
   
  }

  const submit = async e => {
    console.log("fuelType: "+fuelType);
    const bodyObj = JSON.stringify({
      "userId":userId,
      "asDriver":true,
      "registrationNumber":registrationNumber,
      "drivingToSite":true,
      "transportType":transportType,
      "transportSize":transportSize,
      "fuelType":fuelType,
      "siteId":siteId
    });

    try {
      await axiosFetch({
        axiosInstance: axios,
        method: 'post',
        url: '/updateTransportInfo',
        requestConfig: {
          headers: {
            'Content-Type': 'application/json',
          },
          data: bodyObj
        }

      })
    } catch (err) {
      console.log(err);

    }
    setResult(true);
  }

  function submitAction() {
    console.log("RESPONSE: "+response)
    if (response.status === 200) {
      //clear last user info
      setTransportType(null);
      setFuelType(null);
      setRegistrationNumber(null);
      setTransportSize(null);

      navigate("/site-rules");
    }
  }



  return (
    <div>
        <Box className={styles.questionH1Top} >
              <h1>Vehicle Type</h1>
              </Box>
              <Box className={styles.textField}>
              <FormControl fullWidth margin="normal" className={styles.field} error={transportTypeError}>
              <InputLabel id="vehicle-type-label">Vehicle Type</InputLabel>
              <Select
                    labelId="vehicle-type-label"
                    value={transportType}
                    label="Vehicle Type"
                    onChange={handleTransportTypeChange}
                    
                >
                    <MenuItem value={"car"}>Car</MenuItem>
                    <MenuItem value={"motorbike"}>Motorbike</MenuItem>
                    <MenuItem value={"van"}>Van</MenuItem>
                    
                </Select>
                  <FormHelperText>{transportTypeText}</FormHelperText>
              </FormControl>
              </Box>
              <Box className={styles.questionH1} >
              <h1>Type</h1>
              </Box>
              <Box className={styles.textField}>
              <FormControl fullWidth margin="normal" className={styles.field} error={transportSizeError}>
              <InputLabel id="transport-size-label">Type</InputLabel>
              <Select
                    labelId="transport-size-label"
                    value={transportSize}
                    label="Engine Size"
                    onChange={handleTransportSizeChange}

                >
                {engineOptions.map((engineOption) =>
                      <MenuItem key={engineOption.value} value={engineOption.value}>{engineOption.label}</MenuItem>
                  )}
                </Select>
                  <FormHelperText>{transportSizeText}</FormHelperText>
              </FormControl>
              </Box>
              {hideFuel?<></>:<>
                  <Box className={styles.questionH1} >
                    <h1>Fuel Type</h1>
                    </Box>
                    <Box className={styles.textField}>
                    <FormControl fullWidth margin="normal" className={styles.field} error={fuelTypeError}>
                    <InputLabel id="fuel-type-label">Fuel Type</InputLabel>
                    <Select
                          labelId="fuel-type-label"
                          value={fuelType}
                          label="Fuel Type"
                          onChange={handleFuelTypeChange}
                      >
                          {fuelOptions.map((fuelOption) =>
                            <MenuItem key={fuelOption.value} value={fuelOption.value}>{fuelOption.label}</MenuItem>
                        )}
                      </Select>
                        <FormHelperText>{fuelTypeText}</FormHelperText>
                    </FormControl>
                    </Box>
              </>
              }

              <Box className={styles.questionH1}>
              <h1>Vehicle Registration</h1>
              </Box>
              <Box className={styles.textField}>
              <FormControl fullWidth margin="normal" className={styles.field} error={registrationNumberError}>
                 <TextField error={registrationNumberError} autoComplete='off' value={registrationNumber}  fullWidth id="outlined-basic" label="Vehicle Registration" variant="outlined" onChange={e => handleRegistrationNumberChange(e.target.value)}  />
                 <FormHelperText>{registrationNumberText}</FormHelperText>
              </FormControl>
              </Box>


              


              
              <Box className={btnStyles.navbuttons} >
              <Button className={btnStyles.backBtn} size="large" variant="contained" onClick={() => goBack()}>Back</Button>
              <Button className={btnStyles.nextBtn} size="large" variant="contained"
                  onClick={() => nextPage()}
              >Next</Button>

          </Box>
          <Box className={btnStyles.bottomNavContainer}>
              <BottomNavigation sx={{
                  width: '100%',
                  position: 'fixed',
                  bottom: 0,
                  height:'70px',
                  zIndex: '1000'
              }} showLabels>
                  <BottomNavigationAction id="navBackButton" label='Back' onClick={() => goBack()} />
                  <BottomNavigationAction id="navNextButton" label='Next' onClick={() => nextPage()} />
              </BottomNavigation>
          </Box>

    </div>
  );
}

